import { notification } from "antd";
import { put, call, all, takeLatest } from "redux-saga/effects";
import {
  setTiltviewList,
  startTiltviewLoader,
  stopTiltviewLoader,
} from "./actions";
import { FETCH_TILTVIEW_SAGA } from "./type";
import { BASE_URL } from "../../config";
import CacheWithExpiry from "../../helpers/cache/cache";
import fetch from "../../services/fetch";

const cache = new CacheWithExpiry(900000);

function* fetchTiltViewSaga(action) {
  try {
    const { project_id, weld_number, project_name } = action.payload;

    yield put(startTiltviewLoader());

    const key = `Tilt_View_${project_id}_${weld_number}_${project_name}`;

    const cachedData = cache.get(key);

    if (cachedData) {
      yield put(setTiltviewList(cachedData));
      return;
    }

    const url = new URL(`${BASE_URL}/v1/exposed/tilt-view-records`);
    if (project_id) url.searchParams.append("project_id", project_id);
    if (weld_number) url.searchParams.append("weld_number", weld_number);
    if (project_name) url.searchParams.append("project_name", project_name);

    const res = yield fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (res.status === 403) {
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    switch (response.status) {
      case 200:
        {
          cache.set(key, response?.data);
          yield put(setTiltviewList(response?.data));
        }
        break;
      case 410:
        notification.warn({
          message: response?.message,
          duration: 6,
        });
        break;
      default:
        notification.error({
          message: "Something went wrong.",
        });
    }

    yield put(stopTiltviewLoader());
  } catch (error) {
    notification.error({
      message: error.message || "Failed to fetch slogs.",
    });
    yield put(stopTiltviewLoader());
  } finally {
    yield put(stopTiltviewLoader());
  }
}
function* tiltviewWatcher() {
  yield takeLatest(FETCH_TILTVIEW_SAGA, fetchTiltViewSaga);
}

function* tiltviewSagas() {
  yield all([call(tiltviewWatcher)]);
}

export default tiltviewSagas;
